import React, { useEffect, useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import { post, Token, url } from '../../Script/Session';
import { haspermission } from '../../Script/Permission';
import Headline from '../../components/headline/Headline';
import { Box, Breadcrumbs, Button, Dropdown, IconButton, Input, Link, Menu, MenuButton, MenuItem, Table, Tooltip, Typography } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import MoreVert from '@mui/icons-material/MoreVert';
import Upload from '@mui/icons-material/Upload';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
function Downloads() {
    const [wit, setWit] = useState("90.5%");
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [data, setData] = useState("");
    const navigate = useNavigate();
    const [perm, setperm] = useState(haspermission("27"));
    const [dir, setdir] = useState(["/"]);
    useEffect(() => {
        const fetchData = async () => {
            const body = {
                token: Token.get(),
                action: "get",
                dir: dir[0],
            };

            try {
                const response = await post(body, "/downloads/text");
                console.log(response);
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setData(JSON.parse(response));
            } catch (error) {
                console.error("Fehler beim Laden der Daten:", error);
            }
        };

        fetchData();
    }, [navigate]);
    function fetchhome() {
        const body = {
            token: Token.get(),
            action: "get",
            dir: dir[0],
        };

        try {
            const response = post(body, "/downloads/text");
            console.log(response);
            if (response === "LOGOUT") {
                navigate("/");
                return;
            }

            setData(JSON.parse(response));
        } catch (error) {
            console.error("Fehler beim Laden der Daten:", error);
        }
    }
    function getstring() {
        let g = "";
        dir.forEach(a => {
            g += a;
        });
        console.log(g);
        return g;
    }

    const update = async () => {
        const body = {
            token: Token.get(),
            action: "get",
            dir: getstring().replaceAll("//", "/"),
        };

        try {
            const response = await post(body, "/downloads/text");
            console.log(response);
            if (response === "LOGOUT") {
                navigate("/");
                return;
            }

            setData(JSON.parse(response));
        } catch (error) {
            console.error("Fehler beim Aktualisieren der Daten:", error);
        }
    };

    const addDatei = (f) => {
        if (!f) {
            console.log("!f")
            return;
        };
        console.log("Uploading...");

        const formData = new FormData();
        const body = {
            token: Token.get(),
            action: "upload",
            dir: getstring(),
        };

        formData.append("json", JSON.stringify(body));
        formData.append("file", f);

        fetch(url + "/api/downloads/file", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                }
            })
            .catch(console.error);
    };

    const handleChange = (e) => {
        const f = e.target.files[0];
        console.log("change trigger");
        if (f) {
            addDatei(f);
        }
    };

    function deletefile(f) {
        let body = {};
        body.token = Token.get();
        body.action = "deletefile";
        let end = getstring() == "/" ? f : "/" + f;
        body.dir = getstring() + end;
        let response = post(body, "/downloads/text");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            update();
        }

    }
    function createdir() {
        let body = {};
        body.token = Token.get();
        body.action = "createdir";
        let name = prompt("Ordnername");
        if (!name) {
            return;
        }
        let d = getstring() + "/" + name;
        body.dir = d.replaceAll("//", "/");
        let response = post(body, "/downloads/text");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            update();
        }
    }
    function nav(name) {
        let a = dir;
        a.push(name);
        setdir(removeUndefined(a));
        update();
    }
    function backnav(name) {
        if (name == "/") {
            setdir(["/"]);
            fetchhome();
            
            return;
        }
        let a = cutListAfterValue(dir, name);
        setdir(a);
        update();
        
    }
    function removeUndefined(list) {
        return list.filter(item => item !== undefined);
    }
    function cutListAfterValue(list, value) {
        const index = list.indexOf(value);
        if (index !== -1) {
            return list.slice(0, index + 1); // +1 wenn der Wert enthalten bleiben soll
        }
        return list; // Wert nicht gefunden → Liste bleibt unverändert
    }
    return (
        <>
            <div style={{
                width: wit,
                position: "fixed",
                flexDirection: "column",
                top: "0",
                right: "0",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                overflowY: "auto"
            }}>
                <Headline title={`Downloads`} />

                <Box sx={{ width: "100%", display: "flex", justifyContent: "space-evenly", flexDirection: "row", mt: 3 }}>
                            <input
                                type="file"
                                id="file-upload"
                                style={{ display: 'none' }}
                                onChange={(e) => handleChange(e)}
                            />


                    {
                        perm && (
                            <label htmlFor="file-upload">
                                <Tooltip title="Datei auswählen">
                                    <IconButton component="span" variant='solid' sx={{ color: "white" }} color="primary">
                                        <Upload />
                                        <Typography sx={{ ml: 1, color: "white" }}>Datei Hochladen</Typography>
                                    </IconButton>
                                </Tooltip>
                            </label>
                        )
                    }

                    {
                        perm && (
                            <label>
                                <Tooltip title="Ordner erstellen">
                                    <IconButton onClick={() => createdir()} component="span" variant='solid' sx={{ color: "white" }} color="primary">
                                        <Upload />
                                        <Typography sx={{ ml: 1, color: "white" }} >Ordner erstellen</Typography>
                                    </IconButton>
                                </Tooltip>
                            </label>
                        )
                    }

                    <Input
                        placeholder="Suche..."
                        startDecorator={<SearchIcon />}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setDebouncedSearchTerm(e.target.value);
                        }}
                        sx={{ width: 500 }}
                    />
                    {perm && (
                        <Button onClick={() => navigate("/page-history/downloads")}>
                            Historie
                        </Button>
                    )}

                </Box>
                <Box sx={{ width: "100%" }}>
                    <Breadcrumbs size='lg'>
                        {
                            removeUndefined(dir).map(i => {
                                if (i == "/") {
                                    return (<div onClick={() => backnav("/")}><Link>Home</Link></div>);
                                }
                                return <div onClick={() => backnav(i)}><Link>{i.replaceAll("/", "")}</Link></div>
                            })
                        }
                    </Breadcrumbs>
                    <Typography level="body-sm" sx={{color:"red", ml: "1%"}}>Navigation bitte immer doppelclicken</Typography>
                </Box>

                <Table sx={{ '& thead th:nth-child(1)': { width: '1.5%' } }}>
                    <thead>
                        <tr>
                            <th>Art</th>
                            <th>Dateiname</th>
                            <th>Größe</th>
                            <th>Sonstiges</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(data.result) && data.result.length > 0 ? data.result
                            .slice()
                            .sort((a, b) => b.stamp - a.stamp)
                            .filter(item => item.name?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
                            .map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {
                                            item.folder ?
                                                (<FolderOpenOutlinedIcon />) :
                                                (<InsertDriveFileOutlinedIcon />)
                                        }
                                    </td>
                                    <td><div onClick={() => nav("/" + item.name)}><Link>{item.name}</Link></div></td>
                                    <td>
                                        {item.size}KB
                                    </td>
                                    <td>

                                        <Dropdown>
                                            <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                                                <MoreVert />
                                            </MenuButton>
                                            <Menu>
                                                {

                                                    !item.folder && (
                                                        <MenuItem
                                                            onClick={() => {
                                                                console.log(`${url}/downloads/${(getstring().replaceAll("//", "/") + item.name).replaceAll("/", "<|>")}`)
                                                                window.open(
                                                                    `${url}/api/downloads/${(getstring().replaceAll("//", "/") + "/" + item.name).replaceAll("/", "<|>")}`,
                                                                    "_blank",
                                                                    "noopener,noreferrer"
                                                                )
                                                            }}

                                                        >Herunterladen</MenuItem>
                                                    )
                                                }
                                                {perm && (
                                                    <MenuItem sx={{ color: "red" }} onClick={() => deletefile(item.name)}>Datei löschen</MenuItem>
                                                )}

                                            </Menu>
                                        </Dropdown>






                                    </td>
                                </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={4}>Keine Daten vorhanden.</td>
                                </tr>
                            )}
                    </tbody>
                </Table>
            </div>
            <NavigationBar state={"home"} back={false} />
        </>
    )
}

export default Downloads
